import { Overlay, Tool } from 'trading-vue-js';
import Icons from './icons.json';
import Pin from './primitives/pin.js';
import Seg from './primitives/seg.js';
import Line from './primitives/line.js';
import Ray from './primitives/ray.js';

export default {
    name: 'LineTool',
    mixins: [Overlay, Tool],
    methods: {
        meta_info() {
            return { author: 'C451', version: '1.1.0' };
        },
        tool() {
            return {
                // Descriptor for the tool
                group: 'Lines',
                icon: Icons['horizontal.png'],
                type: 'Horizontal',
                //hint: 'This hint will be shown on hover',
                data: [], // Default data
                settings: { horizontal: true }, // Default settings
                // Modifications
                mods: {
                    /* Segment: {
                        
                        // Rewrites the default setting fields
                        settings: { segment: true },
                        icon: Icons['segment.png'],
                    }, */
                    /* Extended: {
                        // Rewrites the default setting fields
                        settings: { extended: true },
                        icon: Icons['extended.png'],
                    },
                    Ray: {
                        // Rewrites the default setting fields
                        settings: { ray: true },
                        icon: Icons['ray.png'],
                    },*/
                },
            };
        },
        // Called after overlay mounted
        init() {
            // First pin is settled at the mouse position
            if (this.sett['segment'] || this.sett['extended'] || this.sett['ray']) {
                this.sett['horizontal'] = false;
            }
            if (this.settings.$state != 'finished') {
                this.sett['color'] = window.localStorage.getItem('linecolor') || '#42b28a';
                this.sett['lineWidth'] = window.localStorage.getItem('linewidth') || 0.9;
            }
            // Second one is following mouse until it clicks

            this.pins.push(new Pin(this, 'p1'));
            this.pins.push(
                new Pin(this, 'p2', {
                    state: 'tracking',
                })
            );
            this.pins[1].on('settled', () => {
                if (this.sett['horizontal']) {
                    this.pins[1].y = this.pins[0].y;
                    this.pins[1].y$ = this.pins[0].y$;
                }
                // Call when current tool drawing is finished
                // (Optionally) reset the mode back to 'Cursor'
                this.set_state('finished');
                this.$emit('drawing-mode-off');
            });
        },
        draw(ctx) {
            if (!this.p1 || !this.p2) return;

            ctx.lineWidth = this.line_width;
            ctx.strokeStyle = this.color;
            ctx.beginPath();
            if (this.sett.horizontal) {
                this.pins[1].y = this.pins[0].y;
                this.pins[1].y$ = this.pins[0].y$;
                new Seg(this, ctx).draw(this.p1, [this.p2[0], this.p1[1]]);
            } else if (this.sett.ray) {
                new Ray(this, ctx).draw(this.p1, this.p2);
            } else if (this.sett.extended) {
                new Line(this, ctx).draw(this.p1, this.p2);
            } else {
                new Seg(this, ctx).draw(this.p1, this.p2);
            }

            ctx.stroke();
            this.render_pins(ctx);
        },
        use_for() {
            return ['LineTool'];
        },
        data_colors() {
            return [this.color];
        },
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings;
        },
        p1() {
            return this.$props.settings.p1;
        },
        p2() {
            return this.$props.settings.p2;
        },
        line_width() {
            return this.sett.lineWidth || 0.9;
        },
        color() {
            return this.sett.color || '#42b28a';
        },
    },
    data() {
        return {};
    },
};
